/**
 * <carousel-slider>: a horizontal scroll-snap track ([data-carousel-track]) with
 * previous/next buttons ([data-carousel-prev] / [data-carousel-next]).
 * Swipe and keyboard scrolling work natively; the buttons move by one item and
 * are disabled at the ends. No autoplay.
 */
class CarouselSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.prev = this.querySelector('[data-carousel-prev]');
    this.next = this.querySelector('[data-carousel-next]');
    if (!this.track) return;

    this.prev?.addEventListener('click', () => this.move(-1));
    this.next?.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    window.addEventListener('resize', () => this.update());
    this.update();
  }

  move(direction) {
    const item = this.track.firstElementChild;
    if (!item) return;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollBy({
      left: direction * (item.getBoundingClientRect().width + gap),
      behavior: reduceMotion ? 'auto' : 'smooth',
    });
  }

  update() {
    const max = this.track.scrollWidth - this.track.clientWidth - 2;
    if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
    if (this.next) this.next.disabled = this.track.scrollLeft >= max;
    this.toggleAttribute('data-scrollable', max > 0);
  }
}

if (!customElements.get('carousel-slider')) customElements.define('carousel-slider', CarouselSlider);
